<template>
<div id="adsense-analysis">
    <c-body :wrap="false">
        <header slot="header" class="c-body-header">
            <div class="header-row">
                <div class="header-row-left">
                    <!-- 搜索 -->
					<Input v-model="tableParams.keyword" 
						   placeholder="请输入广告位ID"
						   class="header-search"
						   icon="android-search"
						   @on-keydown.enter="getList(true)"
						   @on-click="getList(true)" />

                    <!-- 媒体分类筛选 -->

					<Dropdown trigger="click" @on-click="onChangeCategory">
                        <button class="header-button-ghost" style="width:180px">
                            <span class="header-button-ghost-span">{{categoryList[tableParams.categoryCode]?categoryList[tableParams.categoryCode]:'全部'}}</span>
                            <i class="icon header-button-ghost-down"></i>
                        </button>
						<DropdownMenu slot="list">
							<DropdownItem :name="''" :selected="!tableParams.categoryCode">全部</DropdownItem>
							<DropdownItem v-for="(value,key) in categoryList"
										  :name="key"
										  :selected="key==tableParams.categoryCode"
										  :key="key">{{value}}</DropdownItem>
						</DropdownMenu>
					</Dropdown>
					<Button @click="onClickDown" type="primary" style="margin-right:0.06rem;">下载</Button>
                    <Button @click="show.blackAdsense=true" type="info">屏蔽广告位</Button>
                </div>

                <div class="header-row-right">
					<!-- 预设日期按钮 -->
					<c-date-picker :startDay.sync="tableParams.startDay" 
                                   :endDay.sync="tableParams.endDay"
                                   :defaultDate="defaultDate"
                                   @change="getList" />
				</div>
            </div>
        </header>

		<!-- 主体section模块 -->
		<section slot="section" class="c-body-section" style="overflow-x:auto">
			<!-- 表格 -->
			<table class="c-body-table">
				<!-- 表格标题 -->
				<thead class="table-thead">
					<tr class="table-tr">
						<td v-for="item in tableList"
							:key="item.title"
							class="table-td-primary table-sort"
                            style="min-width:140px"
							:class="{'active':tableParams.orderName==item.value,'table-td-long':item.title=='广告位名称'}"
							:style="{cursor:item.value?'pointer':''}"
							@click="sortTable(item.value)">
							<span>{{item.title}}</span>
							<Icon v-if="tableParams.orderName==item.value" 
								  :class="{'table-sort-icon':tableParams.orderType=='asc'}"
								  type="arrow-down-b" />
						</td>
					</tr>
				</thead>

                <tbody class="table-tbody">
                    <tr class="table-tr" v-for="(item,index) in originData" :key="index">
                        <td class="table-td-primary">{{item.code}}</td>
                        <td class="table-td-long"><p class="ad-title" :title="item.name">{{item.name}}</p></td>
                        <td class="table-td-primary">{{item.categoryName}}</td>
                        <td class="table-td-primary">{{item.bid}}</td>
                        <td class="table-td-primary">{{item.imp}}</td>
                        <td class="table-td-primary">{{item.click}}</td>
                        <td class="table-td-primary">{{item.ctr}}</td>
                        <td class="table-td-primary">{{item.cpa}}</td>
                        <td class="table-td-primary">{{item.cpc}}</td>
                        <td class="table-td-primary">{{item.cpm}}</td>
                        <td class="table-td-primary">{{item.calculateImp}}</td>
                        <td class="table-td-primary">{{item.calculateClick}}</td>
                        <td class="table-td-primary">{{item.calculateSpends}}</td>
                        <td class="table-td-primary">{{item.calculateCpc}}</td>
                        <td class="table-td-primary">{{item.calculateCpm}}</td>
                        <td class="table-td-primary">{{item.install}}</td>
                        <td class="table-td-primary">{{item.installRate}}</td>
                        <td class="table-td-primary">{{item.deal}}</td>
                        <td class="table-td-primary">{{item.dealRate}}</td>
                        <td class="table-td-primary">{{item.ecpm}}</td>
                        <td class="table-td-primary">{{item.amount}}</td>
                        <td class="table-td-primary">{{item.payPrice}}</td>
                    </tr>
                </tbody>
			</table>
		</section>
        <footer slot="footer" class="c-body-footer">
            <!-- 分页器 -->
            <c-page :table-params.sync="tableParams" 
                    :page-bean.sync="pageBean"
                    class="foot-row"
                    @on-change="getList(false)"
                    @on-page-size-change="getList(true)" />
        </footer>
    </c-body>

    <Modal v-model="show.blackAdsense"
	       title="屏蔽广告位"
	       ok-text="保存"
           width="650">
           <div class="black-item auto">
                <div class="black-row auto">
                    <span class="black-label">自动屏蔽</span>
                    <i-switch v-model="globalRuleStatus" :true-value="1" :false-value="0">
                        <span slot="open">开</span>
                        <span slot="close">关</span>
                    </i-switch>
                    <span style="margin-left:0.1rem;font-size:0.12rem;">规则：30天内展示量>50w且ecpm小于$0.005拉黑广告位</span>
                </div>
           </div>
           <div class="black-list">
               <div v-for="(item,index) in adsenseBlackList" class="black-item" :key="index">
                   <div class="black-row">
                        <span class="black-label">国家</span>
                        <cDropdown  v-if="countryList.length" 
                                    v-model="item.countries" 
                                    :sourceList="countryList" 
                                    code="code" label="code" 
                                    :status.sync="item.status">
                            <Input :title="item.countries"
                                    class="black-input"
                                    style="width:2.63rem"
                                    readonly 
                                    :value="item.countries?item.countries:'全部'" 
                                    icon="arrow-down-b" />
                        </cDropdown>
                        <a @click="adsenseBlackList.splice(index,1)" class="black-delete">删除</a>
                   </div>
                   <div class="black-row">
                       <span class="black-label">广告位</span>
                       <Input v-model="item.adsenseIds" type="textarea" :rows="4" placeholder="请输入要屏蔽的广告位，逗号分隔" />
                   </div>
               </div>
           </div>
           <div class="black-item add">
               <div class="black-row">
                   <span class="black-label"></span>
                   <Button @click="addBlackItem" size="large" type="primary">新增屏蔽</Button>
                </div>
           </div>
            <!-- 底部按钮 -->
            <div slot="footer">
                <Button type="text" @click="show.blackAdsense=false">取消</Button>
                <Button type="primary" size="large" @click="saveBlackAdsense">保存</Button>
            </div>
	</Modal>
</div>
</template>
<script>
import cBody from '@/components/commons/cBody.vue';
import cPage from '@/components/commons/cPage.vue';
import cDatePicker from '@/components/commons/cDatePicker.vue';
import cDropdown from '@/components/commons/cDropdown.vue';
import mixins from '@/mixins/index.js';
export default {
    name: 'AdsenseAnalysis',
    mixins: [mixins],
    components: {
        cBody,
        cPage,
        cDatePicker,
        cDropdown,
    },
    data() {
        return {
            //表头
            tableList: [
                { title: '广告位ID', value: 'code' },
                { title: '广告位名称', value: 'name' },
                { title: '媒体分类', value: 'categoryName' },
                { title: '竞价请求量', value: 'bid' },
                { title: '展现量', value: 'imp' },
                { title: '点击量', value: 'click' },
                { title: 'CTR', value: 'ctr' },
                { title: 'CPA', value: 'cpa' },
                { title: 'CPC', value: 'cpc' },
                { title: 'CPM', value: 'cpm' },
                { title: '补/扣量后的clickimp数', value: 'calculateImp' },
                { title: '补/扣量后的click数', value: 'calculateClick' },
                { title: '补/扣量后的花费数', value: 'calculateSpends' },
                { title: '补/扣量后的cpc', value: 'calculateCpc' },
                { title: '补/扣量后的cpm', value: 'calculateCpm' },
                { title: '安装量', value: 'install' },
                { title: '安装率', value: 'installRate' },
                { title: '转化量', value: 'deal' },
                { title: '转化率', value: 'dealRate' },
                { title: 'eCPM', value: 'ecpm' },
                { title: '收益', value: 'amount' },
                { title: '支出', value: 'payPrice' },
            ],
            //列表数据
            originData: [],
            //分页对象
            pageBean: {
                currentPage: 1,
                pageSize: 10,
                startNum: 0,
                totalNum: 0,
                totalPage: 0,
            },
            //获取列表参数
            tableParams: {
                keyword: '',
                page: 1,
                pageSize: 10,
                dimension: 'adsense',
                startDay: this.mixinGetDate('today'),
                endDay: this.mixinGetDate('today'),
                orderName: 'code',
                orderType: 'desc',
                categoryCode: '',
            },
            //全局自动优化规则
            globalRuleStatus: 0,
            //广告黑名单
            adsenseBlackList: [],
            adsenseBlackTemplate: { countries: '', adsenseIds: '', status: '全部' },
            //国家列表
            countryList: [],
            //媒体分类列表
            categoryList: {},
            show: { blackAdsense: false },
            //预设日期按钮
            defaultDate: [
                {
                    type: '今天',
                    startDay: this.mixinGetDate('today'),
                    endDay: this.mixinGetDate('today'),
                },
                {
                    type: '昨天',
                    startDay: this.mixinGetDate('yesterday'),
                    endDay: this.mixinGetDate('yesterday'),
                },
                {
                    type: '近一周',
                    startDay: this.mixinGetDate('week'),
                    endDay: this.mixinGetDate('yesterday'),
                },
            ],
        };
    },
    created() {
        this.adsenseBlackList.push(Object.assign({}, this.adsenseBlackTemplate));
        this.getList();
        this.getBlackAdsense();
        this.getCategoryList();
        this.getCountryList();
    },
    methods: {
        /*
		 * @description 获取列表
		 * @param isInit:boolean 是否初始化
		 */
        async getList(isInit = false) {
            if (isInit) this.tableParams.page = 1;
            const res = await this.$axios.get(this.$port.globalReport.list, { params: this.tableParams, cancelLoading: true });
            this.originData = res.data.list;
            this.pageBean = res.data.pageBean;
        },
        /*
		 * @description 获取媒体分类列表
		 */
        async getCategoryList() {
            const res = await this.$axios.get(this.$port.manager.getCategoryList);
            res.data.list.forEach(item => {
                this.categoryList = Object.assign({ [item.categoryCode]: item.categoryName }, this.categoryList);
            });
        },
        /*
		 * @description 获取媒体分类列表
		 */
        async getCountryList() {
            const res = await this.$axios.get(this.$port.manager.getCountryList);
            this.countryList = res.data;
        },
        /*
		 * @description 获取广告黑名单
		 */
        async getBlackAdsense() {
            const res = await this.$axios.get(this.$port.globalReport.getBlackAdsense);
            this.adsenseBlackList = res.data.list.map(item =>
                Object.assign({ status: item.countries ? `已选${item.countries.split(',').length}项` : '全部' }, item)
            );
            this.globalRuleStatus = res.data.globalRuleStatus;
        },
        /*
		 * @desc 添加屏蔽
		 */
        async addBlackItem() {
            this.adsenseBlackList.push(Object.assign({}, this.adsenseBlackTemplate));
        },
        /*
		 * @description 保存广告黑名单
		 */
        async saveBlackAdsense() {
            //如果有没填写的广告位
            if (!this.adsenseBlackList.every(item => item.adsenseIds)) {
                this.$Message.error({ content: '请填写屏蔽的广告位', duration: 1.5 });
                return;
            }
            const res = await this.$axios.post(this.$port.globalReport.updateBlackAdsense, {
                list: this.adsenseBlackList,
                globalRuleStatus: this.globalRuleStatus,
            });
            if (res.status == 200) {
                if (res.message) this.$Modal.success({ content: `已过滤非法ID并保存：${res.message}` });
                else this.$Message.success({ content: '保存成功', duration: 1.5 });
                await this.getBlackAdsense();
                this.show.blackAdsense = false;
            } else {
                this.$Modal.error({ content: res.message });
            }
        },
        /*
         * @description 报表下载
         */
        onClickDown() {
            let initString = `${this.$port.globalReport.download}?rd=${new Date().getTime()}`;
            window.location.href = Object.entries(this.tableParams).reduce((a, b) => `${a}&${b[0]}=${b[1]}`, initString);
        },
        /*
		 * @description 媒体分类筛选
		 * @param value:string 选择的媒体分类
		 */
        onChangeCategory(value) {
            this.$set(this.tableParams, 'categoryCode', value);
            this.getList(true);
        },
        /*
		 * @description 表格排序
		 * @param value:string 排序的索引
		 */
        sortTable(value) {
            // 无效排序返回
            if (!value) return;
            if (value == this.tableParams.orderName) {
                this.tableParams.orderType = this.tableParams.orderType == 'asc' ? 'desc' : 'asc';
            } else {
                this.tableParams.orderName = value;
                this.tableParams.orderType = 'desc';
            }
            this.getList(true);
        },
    },
};
</script>
<style lang="scss">
#adsense-analysis {
    .ivu-select-dropdown {
        overflow: auto;
        max-height: 3rem;
    }

    .ad-title {
        line-height: 20px;
    }
}
.black-list {
    padding: 0.1rem;
    max-height: 3.52rem;
    overflow: auto;
    border-bottom: 1px solid #e5e5e5;
}
.black-item {
    border-top: 1px solid #e5e5e5;
    padding: 0.15rem 0;
    &.add {
        padding: 0.15rem 0.12rem;
        border-top: 0;
        border-bottom: 1px solid #e5e5e5;
    }
    &.auto {
        padding: 0.1rem 0.12rem;
        padding-bottom: 0;
        .black-row {
            align-items: center;
        }
    }
    .black-row {
        position: relative;
        display: flex;
        line-height: 0.36rem;
        &:not(:nth-last-of-type(1)) {
            margin-bottom: 0.1rem;
        }
        font-size: 14px;
        .black-label {
            flex: 0 0 56px;
            margin-right: 0.12rem;
            text-align: end;
        }
        .black-delete {
            position: absolute;
            line-height: 0.36rem;
            top: 0;
            right: 0;
        }
        .black-input {
            input {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/view/DataAnalysis/AdsenseAnalysis.vue